export default __webpack_public_path__ + "static/media/kitchen4-afterE.cc70c0e4.jpg";